import { MyOptionType } from '@procsea/design-system'

interface Entity {
  id: Id
  name: string
}

export const getNewEntitiesOptions = <T extends Entity>(
  entities?: T[] | null
): MyOptionType<Id>[] => {
  if (!Array.isArray(entities)) return []
  return entities.map(({ id, name }) => ({ value: id, label: name }))
}
